export default {
  identifyGroupCode: 'identify group code',
  identifyGroupName: 'identify group name',
  identifyCode: 'identify code',
  identifyName: 'identify name',
  indentifyClass: 'identify type',
  indentifyType: 'identify type',
  ConfirmDeleteTheIdentifyGroup: 'are you sure to delete this identity group?',
  pleaseSelectIdentifyGroup: 'please select the identify group first',
  createIdentify: 'create a identify',
  editIdentify: 'edit the identify',
  viewIdentify: 'view the identify',
  createIdentifyGroup: 'create a identify group',
  editIdentifyGroup: 'edit the identify group',
  viewIdentifyGroup: 'view the identify group',
  pleaseSelectDeleteIdentify: 'please the delete identify',
  confirmDeleteTheIdentify: 'are you sure t o delte this identify',
}
